import { BusinessSchema } from '@40seas/entities/businesses';
import { Buyer } from '@40seas/entities/buyers';
import { CheckoutResult, CheckoutResultSchema } from '@40seas/entities/checkout';
import { EnumSchema, FromSchema, ZodDate } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import {
    Address,
    AddressSchema,
    BaseEntity,
    Currency,
    LineItem,
    LineItemSchema,
    PercentageValue,
    PercentageValueSchema,
    WithBaseEntitySchema,
} from '@40seas/models';
import { z } from 'zod';
import { OrderStatus } from './order.status.enum';

export const OrderSchema = WithBaseEntitySchema(
    z.object({
        externalId: z.string().optional(),
        buyer: z
            .string()
            .regex(/^[0-9a-f]{24}$/i)
            .or(BusinessSchema),
        checkout: z.string().optional(),
        lineItems: z.array(LineItemSchema).optional(),
        amount: z.number().gt(0, 'Order amount must be greater than 0'),
        currency: EnumSchema(Currency),
        discount: PercentageValueSchema.optional(),
        amountPaid: z.number().optional(),
        shippingFee: z.number().optional(),
        tax: PercentageValueSchema.optional(),
        shippingAddress: AddressSchema.optional(),
        billingAddress: AddressSchema.optional(),
        status: EnumSchema(OrderStatus),
        consents: z.boolean().optional(), // TODO: Replace with Consents API
        result: CheckoutResultSchema.optional(),
        seller: z
            .string()
            .regex(/^[0-9a-f]{24}$/i)
            .or(BusinessSchema),
        metadata: z.record(z.string()).optional(),
        timeline: z.record(z.object({ updatedAt: ZodDate })).optional(),
    }),
).strict();

export class Order extends FromSchema(OrderSchema) implements BaseEntity {
    id: string;
    externalId?: string;
    buyer: string | Buyer;
    checkout?: string;
    lineItems?: LineItem[];
    amount: number;
    currency: Currency;
    discount?: PercentageValue;
    amountPaid?: number;
    shippingFee?: number;
    tax?: PercentageValue;
    shippingAddress?: Address;
    billingAddress?: Address;
    status: OrderStatus;
    consents?: boolean; // TODO: Replace with Consents API
    result?: CheckoutResult;
    seller: string | Seller;
    createdAt: Date;
    updatedAt: Date;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
